<template>
    <div style="background: #fff">
      <div style="padding: 10px;font-size: 14px;text-align: left">
        <p>您的设备：{{query.iccid}}，已于{{query.expireDate}}到期</p>
        <p>为了不影响您的使用，或由于长期未续费导致设备注销， 请您及时进行续费。</p>
        <p>若设备丢失或已注销无法续费，您可以点击下方更换设备，获取新的设备</p>
      </div>
      <div style="width: 200px;margin: 1rem auto;font-size: 22px">
        <div @click="exchange" class="gumaibtn" style="float:left;display:inline-block;width: 80px;height: 80px;background: #0e65b1;color: #fff">
          <div style="margin-top: 10px">更换</div><div>设备</div>
        </div>
        <div @click="recharge" class="xufei" style="display:inline-block;width: 80px;height: 80px;background: #08a543;color: #fff;margin-left: 40px">
          <div style="margin-top: 10px">立即</div><div>续费</div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "expirenotice",
      data(){
         return {
           query:{}
         }
      },
      methods:{
        recharge(){
          this.$router.push({name:"recharge",query:this.query})
        },
        exchange(){
          this.$router.push({name:"exchange",query:this.query})
        }
      },
      created() {
          this.query = this.$route.query
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/expirenotice.vue